import axios from '../../helpers/axios'

export default {
  state:{
    becomeOwnerProcess:null,
    becomeOwnerSuccess:null,
    becomeOwnerError:null
  },
  getters:{
    becomeOwnerProcess: state => state.becomeOwnerProcess,
    becomeOwnerSuccess: state => state.becomeOwnerSuccess,
    becomeOwnerError: state => state.becomeOwnerError
  },
  mutations:{
    BECOME_OWNER_PROCESS (state, payload) {
      state.becomeOwnerProcess = payload
    },
    BECOME_OWNER_SUCCESS (state, payload) {
      state.becomeOwnerSuccess = payload
    },
    BECOME_OWNER_ERROR (state, payload) {
      state.becomeOwnerError = payload
    },
    CLEAR_BECOME_OWNER (state) {
      state.becomeOwnerProcess = null
      state.becomeOwnerSuccess = null
      state.becomeOwnerError = null
    }
  },
  actions:{
    changeUserRoleToOwner ({commit, dispatch, rootState}) {
      commit('CLEAR_BECOME_OWNER')
      commit('BECOME_OWNER_PROCESS', true)
      const config = {
        method: 'post',
        url: '/oauth/user/become-a-owner',
        headers: { 
          'Authorization': `Bearer ${rootState.user.token}`
        }
      }
      axios(config).then(result => {
        commit('BECOME_OWNER_PROCESS', true)
        if (result.data) {
          dispatch('getUser')
          
        } else {
          commit('BECOME_OWNER_ERROR', true)
        }
      }).catch(error => {
       
        commit('BECOME_OWNER_PROCESS', false)
        if (error.response) {
          commit('BECOME_OWNER_ERROR', error.response)
        } else if (error.request) {
          commit('BECOME_OWNER_ERROR', error.request)
        } else {
          commit('BECOME_OWNER_ERROR', error.message)
        }
        setTimeout(() => {
          commit('CLEAR_BECOME_OWNER')
        }, 3000)
      })
    }
  }
}